import * as firebase from 'firebase';
require("firebase/firestore");

var collectionMeta={
	//Actividades
	"actividades": {
		"fields": {
			"0_abierta": "si", 
			"1_nombre": "Nombre de la actividad",
			"2_preguntas": 0,
			"3_texto_inicio": "Texto de inicio",
			"4_texto_fin": "Texto final",
			"5_imagen_fondo": "",
			"6_logo": "",
			"7_marker_mapa": "",
			"8_css_ios": "",
			"9_css_android": "",
			"10_config": {
				"minDistance": 50,
				"minTimePeriod": 50
			},
			"11_visible": "no"
		},
		"collections":["preguntas"]
	},
	"preguntas": {
		"fields": {
			"01_paso": 1,
			"02_tipo": "formulario",
			"03_fondo": "",
			"04_titulo_pregunta": "Título de la pregunta",
			"05_texto_pregunta": "Pregunta",
			"06_texto_respuesta": "Respuesta",
			"07_localizacion": new firebase.firestore.GeoPoint(0.00, 0.00),
			"08_texto_marker": "Texto marker",
			"09_ubicacion": "si",
			"10_pista_1": "Pista 1 (intento 4)",
			"11_fondo_pista_1": "",
			"12_pista_2": "Pista 2 (intento 7)",
			"13_fondo_pista_2": "",
			"14_pista_respuesta": "Pista final (intento 11)",
			"15_fondo_pista_respuesta": "",
		}
	},
	"TEMPLATE":{
		"fields":{},
		"collections":[]
	}
}

module.exports=collectionMeta;


// WEBPACK FOOTER //
// ./src/config/firestoreschema.js